import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { BRAND } from "../config/brand";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [devUrl, setDevUrl] = useState(""); // populated when backend in dev mode

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        try {
            const r = await api.post("/auth/forgot-password", { email: email.trim() });
            setSent(true);
            if (r.data?.dev_reset_url) {
                setDevUrl(r.data.dev_reset_url);
                toast.info("DEV MODE: link reset visibile sotto");
            } else {
                toast.success("Controlla la tua email");
            }
        } catch (err) {
            toast.error(err.response?.data?.detail || "Errore. Riprova.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50">
            <div className="w-full max-w-md bg-white border border-zinc-200">
                <div className="h-1 bg-signal" />
                <div className="p-10">
                    <Link
                        to="/login"
                        className="inline-flex items-center gap-2 text-xs text-zinc-500 hover:text-ink mb-6"
                        data-testid="link-back-to-login"
                    >
                        <ArrowLeft size={12} weight="bold" />
                        Torna al login
                    </Link>

                    <div className="overline mb-2">{BRAND.name}</div>
                    <h1 className="text-3xl font-black tracking-tighter mb-2">
                        Reset password
                    </h1>
                    <p className="text-sm text-zinc-600 mb-8 leading-relaxed">
                        {sent
                            ? "Se l'email è registrata, riceverai a breve un link per il reset. Il link è valido 1 ora."
                            : "Inserisci la tua email e ti invieremo un link per impostare una nuova password."}
                    </p>

                    {!sent ? (
                        <form onSubmit={submit}>
                            <label className="block mb-6">
                                <div className="overline mb-2">Email</div>
                                <input
                                    type="email"
                                    className="inp"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoFocus
                                    data-testid="forgot-email-input"
                                    autoComplete="email"
                                />
                            </label>
                            <button
                                type="submit"
                                disabled={loading}
                                className="btn-primary w-full inline-flex items-center justify-center gap-2"
                                data-testid="forgot-submit-button"
                            >
                                <EnvelopeSimple size={14} weight="bold" />
                                {loading ? "Invio…" : "Invia link reset"}
                            </button>
                        </form>
                    ) : (
                        <div data-testid="forgot-sent-confirmation">
                            <div className="p-4 bg-zinc-50 border border-zinc-200 text-sm text-zinc-700 mb-4">
                                ✓ Email inviata a <strong>{email}</strong>
                            </div>
                            {devUrl && (
                                <div className="p-4 bg-amber-50 border border-amber-300 text-xs mb-4">
                                    <div className="font-bold mb-2">DEV MODE — link diretto:</div>
                                    <a
                                        href={devUrl}
                                        className="break-all underline text-amber-900"
                                        data-testid="forgot-dev-url"
                                    >
                                        {devUrl}
                                    </a>
                                </div>
                            )}
                            <Link to="/login" className="btn-secondary w-full inline-flex items-center justify-center">
                                Torna al login
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
